import { BackButton } from "@/components/BackButton";
import { PageTransition } from "@/components/PageTransition";
import { Checkbox } from "@photo-booth/ui/checkbox";
import { useFrameStore } from "@/lib/store/frameStore";
import { Navigate } from "react-router";
import { useSEO } from "@/lib/seo/useSEO";
import { useState } from "react";
import { AgreementModal } from "@/components/AgreementModal";

export const FrameDetailPage: React.FC = () => {
  const { frame } = useFrameStore();
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  useSEO({
    title: `${frame?.name} - Frame Details`,
    description: `View details for ${frame?.name} frame. Perfect for your photo booth experience with ${frame?.imagesCount} photo layout.`,
    keywords: `${frame?.name}, photo frame, photo booth frame, KeptScene`,
    image: frame?.sampleImageUrl,
  });

  if (!frame) {
    return <Navigate to="/frame" />;
  }

  const [row, col] = frame.layout.split("x").map(Number);
  const isVertical = row > col;

  return (
    <PageTransition>
      <BackButton prevUrl="/frame?type=monthly" />
      <div className="px-4 py-4 h-screen-safe-area overflow-y-hidden">
        <div className="flex flex-col items-center">
          <h1 className="text-4xl text-vintage-red">Frame Detail</h1>

          <div className="mt-4 min-h-[60vh] flex flex-col items-center justify-center w-full">
            <img
              src={frame.sampleImageUrl}
              alt={`${frame.name} photo frame sample`}
              loading="eager"
              fetchPriority="high"
              decoding="async"
              className="max-h-[60vh] object-contain"
              style={{
                width: isVertical ? "auto" : "100%",
                height: isVertical ? "100%" : "auto",
                boxShadow: "1px 1px 4px 2px #BEBEBE",
              }}
            />
          </div>

          <div
            className="w-full mt-4"
            onClick={() => setIsTermsAccepted(!isTermsAccepted)}
          >
            <div className="flex items-center space-x-2 px-4">
              <Checkbox
                id="terms"
                className="border border-vintage-black"
                checked={isTermsAccepted}
              />
              <p className="text-vintage-black text-sm">
                By ticking this box, you agree to our{" "}
                <a
                  href="/terms-and-privacy-policy"
                  className="text-vintage-red underline"
                >
                  {" "}
                  terms and conditions{" "}
                </a>
              </p>
            </div>
            <div className="flex justify-end mt-4">
              <AgreementModal
                buttonProps={{
                  disabled: !isTermsAccepted,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </PageTransition>
  );
};
